<template>
  <div class="waitingcallMessage waitingcallResult notranslate">
    <button
      type="button"
      class="btnEntrance"
      @click.stop="toEntrancePage()">
    </button>
    <div class="title mb30">
      <h3>{{ locale.unable_verify_rid }}</h3>
      <p class="colorGrey">{{ locale.not_available_waitingcall_rid }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'ln',
    'locale',
    'isPublic',
  ],
  computed: {
    spaceCode () {
      const authInfo = this.$store.getters['authentication/getAuthInfo']
      return authInfo && authInfo.spaceCode
    },
    entranceActive () {
      return this.info && this.info.setting && this.info.setting.entranceActive
    },
  },
  async created () {
    const spaceCode = this.spaceCode
    const infoData = await this.$store.dispatch('waitingcall/getWaitingcallData')
    if (infoData && spaceCode) {
      this.info = infoData[spaceCode]
    }
  },
  data () {
    return {
      info: null
    }
  },
  methods: {
    toEntrancePage () {
      const entranceActive = this.entranceActive
      if (entranceActive) {
        const entranceUrl = this.info && this.info.setting && this.info.setting.entranceUrl
        this.$router.push({
          name: 'page',
          params: {
            ln: this.$route.params.ln,
            id: entranceUrl.pageId
          }
        })
      } else {
        this.$router.push({
          name: 'waitingcallNationality'
        })
      }
    },
  }
}
</script>

